import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import {
  OrderHistoryVariant,
  OrderHistoryVariantMap,
} from "@/features/my-order/features/order-history/types";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  date?: string;
  totalAmount?: number;
  // 금액 통화 — 없으면 유로
  currency?: string;
  totalCount?: string;
  variant: OrderHistoryVariant;
  onClick?: () => void;
}

const variantMap: OrderHistoryVariantMap = {
  orderForm: {
    title: "excel_order_sheet",
    titleIcon: "download",
    sideIcon: "document-text",
    sideIconColor: "#4C994F",
    sideIconBackground: "#F0FAEF",
  },
  confirm: {
    title: "order_confirm",
    titleIcon: "chevron-right",
    sideIcon: "clipboard-check",
    sideIconColor: "#1272EF",
    sideIconBackground: "#F0F9FF",
  },
  orderSheet: {
    title: "order_sheet",
    titleIcon: "chevron-right",
    sideIcon: "document-text",
    sideIconColor: "#B27700",
    sideIconBackground: "#FFF7CC",
  },
};

function OrderHistoryOrderInfoCard({
  variant,
  date,
  totalAmount,
  currency = "EUR",
  totalCount,
  onClick,
}: Props) {
  const { titleIcon, sideIcon, sideIconBackground, sideIconColor, title } =
    variantMap[variant];
  const { t, tTitle, i18n, tCurrencyString } = useI18nHelper();

  return (
    <Flex
      padding={"16px"}
      border={"1px solid #D4D4D1"}
      borderRadius={"8px"}
      onClick={onClick}
      gap={"10px"}
      flex={1}
      cursor={"pointer"}
      _hover={{
        background: "rgba(240, 240, 240, 0.5)",
      }}
      _active={{
        background: "rgba(240, 240, 240, 0.8)",
      }}
    >
      <Flex flexDirection={"column"} gap={"4px"} flex={1}>
        <Text textStyle={"body-sm-regular"} color={"#6F6F6C"}>
          {date}
        </Text>
        <Flex gap={"2px"} alignItems={"center"}>
          <Text textStyle={"body-lg-bold"} color={"#444444"}>
            {tTitle("order_history:" + title)}
          </Text>
          <CustomIcon
            src={titleIcon}
            width={20}
            height={20}
            color={"#8F8F8C"}
          />
        </Flex>
        <Flex alignItems={"center"}>
          <Text textStyle={"body-sm-regular"} color={"#444444"}>
            {t("order_history:quantity")}{" "}
            {totalCount && totalCount !== "0" ? (
              i18n.language === "ko" ? (
                totalCount + "개"
              ) : (
                totalCount
              )
            ) : (
              <span style={{ color: "#C0C0C0" }}>
                {t("order_history:missing")}
              </span>
            )}
          </Text>
          <CustomIcon src={"dot"} width={16} height={16} color={"#D4D4D1"} />
          <Text textStyle={"body-sm-regular"} color={"#444444"}>
            {t("order_history:amount")}{" "}
            {totalAmount && totalAmount !== 0 ? (
              tCurrencyString(totalAmount, { type: "SYMBOL", code: currency })
            ) : (
              <span style={{ color: "#C0C0C0" }}>
                {t("order_history:missing")}
              </span>
            )}
          </Text>
        </Flex>
      </Flex>
      <Box
        padding={"10px"}
        borderRadius={"8px"}
        background={sideIconBackground}
        alignSelf={"flex-start"}
      >
        <CustomIcon
          src={sideIcon}
          width={28}
          height={28}
          color={sideIconColor}
        />
      </Box>
    </Flex>
  );
}

export default OrderHistoryOrderInfoCard;
